<template>
    <div id="preorders">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openCustomerModal = true"
            >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span class="ml-2 text-base text-primary">
                    Criar Orçamento
                </span>
            </div>
        </div>
      <pre-orders-table
        ref="preOrdersTable"
        origin="list"
        @closePopup="treatUnusedMethods"
        @turnIntoOrder="turnIntoOrder"
        @createPreOrder="treatUnusedMethods"
      ></pre-orders-table> 

        <OrderSummaryPopUp
         origin="list"
         :isActive="openOrderSummaryModal"
         :dataOfTurnIntoOrder="dataOfTurnIntoOrder"
         @isActiveFalse="openOrderSummaryModal=false"
         @backToPreOrder="treatUnusedMethods"
         @editDeliveryOptions="treatUnusedMethods"
         @editPaymentOptions="treatUnusedMethods"
         @editProductOptions="treatUnusedMethods"
         :modalToTransformIsActive="modalToTransformIsActive"
         @linkUser="linkUser"
         :selectedUser="selectedUser"
         @removeSelectedUser="selectedUser = null"
         @editNotesAndFiles="editNotesAndFiles"
         @editCustomerKnow="editCustomerKnow"
         :customer="chatTicket.customer"
         @addCustomerDocument="addCustomerDocument"
        />

        <customerKnowledgePopup
         :in-flow="true"
         :is-active="openCustomerKnowledgeModal"
         :customer-id="chatTicket.customer ? chatTicket.customer.id : null"
         :current-know="customerKnowledge"
         @backPage="popupKnowledge"
         @knowledgeClose="popupKnowledge"
         @closeModalCustomerKnow="openCustomerKnowledgeModal = false"
         @setCurrentKnow="setCurrentKnowledge"
         :isUpdate="isUpdate"
         @backUpdateKnow="backUpdateKnow"
         :dataOfTurnIntoOrder="dataOfTurnIntoOrder"
         :customer="null"
         :context="orderContext"
         @backToFinishOrder="backToFinishOrder"
        />

        <LinkUserPopUp
         :isActive="openLinkUserPopUp"
         @isActiveFalse="openLinkUserPopUp=false"
         @backToOrerSummarry="backToOrerSummarry"
         @changeUser="changeUser"
        />

        <Customers
         :isActive="openCustomerModal" 
         @isActiveFalse="openCustomerModal = false" 
         @customerDocument="customerDocument"
        />

        <CustomerDocumentModal
         :isActive="openCustomerDocumentModal"
         :isActiveFalse="openCustomerDocumentModal = false"
         :chatTicket="chatTicket"
         :outOfChat="true"
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         :dataToUpdate="dataToUpdate"
         @backToCustomer="backToCustomer"
         :isCreateContext="isCreateContext"
         @sendToProductSericesFlow="sendToProductSericesFlow"
        />

        <ProductsPopUp 
         :isActive="openProductsModal"
         @isActiveFalse="openProductsModal = false" 
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         :backIsVisible="true"
         :outOfChat="true"
         @backToCustomerDocument="backToCustomerDocument"
         @addQuantity="addQuantity"
         :dataToUpdate="{}"
         :isCreateContext="isCreateContext"
         :updatePreOrder="updatePreOrder"
        />

        <QuantityPopUp
         :isActive="openQuantityModal" 
         @isActiveFalse="openQuantityModal = false"
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         @backToProducts="backToProducts"
         :quantityList="quantity_list"
         @sendDeliveryFlow="sendDeliveryFlow"
         :isCreateContext="isCreateContext"
         :dataToUpdate="dataToUpdate"
         @setDiscountPrice="setDiscountPrice"
         @updatePreOrderProducts="updatePreOrderProducts"
         :updatePreOrder="updatePreOrder"
        />

        <DiscountPopUp
         :isActive="openDiscountModal" 
         @backToQuantity="backToQuantity"
         :dataToSetDiscount="dataToSetDiscount"
         @setNewDiscountPrice="setNewDiscountPrice"
         @setNewDiscountService="setNewDiscountService"
         @backToDiscountModalService="backToDiscountModalService"
        />

        <DeliveryPopUp
         :isActive="openDeliveryModal"
         @isActiveFalse="closeModalDelivery"
         @backToQuantity="backToQuantity"
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         @sendToPayment="sendToPayment"
         :dataToUpdate="dataToUpdate"
         :isCreateContext="isCreateContext"
         @backToOrderSummary="backToOrderSummary"
         @updateOrderDelivery="updateOrderDelivery"
         :chatContact="chatTicket"
        />

        <PaymentPopUp
         :isActive="openPaymentModal"
         @isActiveFalse="closeModalPayment"
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         @sendToNotesAndFiles="sendToNotesAndFiles"
         @backToDelivery="backToDelivery"
         :isCreateContext="isCreateContext"
         @backToOrderSummary="backToOrderSummary"
         :dataToUpdate="dataToUpdate"
         @updateOrderPayment="updateOrderPayment"
         :services="services"
         @backToProducts="backToProducts"
        />

        <NotesAndFilesPopUp
         :isActive="openNotesAndFilesPopUp"
         @isActiveFalse="openNotesAndFilesPopUp = false"
         @sendToPreOrdersSummary="sendToPreOrdersSummary"
         @backToPayment="backToPayment"
        />

        <PreOrderSummaryPopUp
         :isActive="openPreOrderSummaryModal"
         @isActiveFalse="closeModalPreOrders"
         :dataOfProductsToPreOrder="dataOfProductsToPreOrder"
         @backToNotesAndFiles="backToNotesAndFiles"
         :services="services"
         :chatTicket="chatTicket"
         :chatContact="null"
         :outOfChat="true"
         @openDiscountServiceModal="openDiscountServiceModal"
         @editProductsPreOrder="editProductsPreOrder"
        />
    </div>
</template>

<script>
    import PreOrdersTable from "../../chat-attendance/pre-orders/PreOrdersTable";
    import OrderSummaryPopUp from "../../chat-attendance/orders/OrderSummary";
    import Customers from './CustomerModal.vue';
    import CustomerDocumentModal from '../../chat-attendance/customers/CustomerDocument.vue';
    import ProductsPopUp from '../../chat-attendance/products/Products.vue';
    import QuantityPopUp from '../../chat-attendance/products/Quantity.vue';
    import DiscountPopUp from '../../chat-attendance/products/Discount.vue';
    import DeliveryPopUp from '../../chat-attendance/delivery/Delivery.vue';
    import PaymentPopUp from '../../chat-attendance/payments/Payment.vue';
    import PreOrderSummaryPopUp from '../../chat-attendance/pre-orders/PreOrderSummary.vue';
    import LinkUserPopUp from "../../chat-attendance/users/LinkUser.vue";
    import NotesAndFilesPopUp from "../../chat-attendance/notes-and-files/NotesAndFiles.vue";
    import CustomerKnowledgePopup from "@/views/chat-attendance/services/CustomerKnowledgePopup.vue";
    
    export default {
        components: {
            PreOrdersTable,
            OrderSummaryPopUp,
            Customers,
            CustomerDocumentModal,
            ProductsPopUp,
            QuantityPopUp,
            DiscountPopUp,
            DeliveryPopUp,
            PaymentPopUp,
            PreOrderSummaryPopUp,
            LinkUserPopUp,
            NotesAndFilesPopUp,
            CustomerKnowledgePopup
        },
        data() {
            return {
                openOrderSummaryModal: false,
                dataOfTurnIntoOrder: {},
                chatTicket: {},
                dataOfProductsToPreOrder: {},
                dataToUpdate: {},
                openCustomerModal: false,
                openProductsModal: false,
                openPaymentModal: false,
                openQuantityModal: false,
                openDiscountModal: false,
                openDeliveryModal: false,
                openCustomerKnowledgeModal: false,
                openPreOrderSummaryModal: false,
                services: {},
                quantity_list: [],
                isCreateContext: true,
                dataToSetDiscount: {},
                modalToTransformIsActive: false,
                openLinkUserPopUp: false,
                selectedUser: null,
                openNotesAndFilesPopUp: false,
                customerKnowledge: null,
                isUpdate: false,
                orderContext: '',
                updatePreOrder: false,
            }
        },
        methods: {
            treatUnusedMethods() {
            },
            turnIntoOrder(value) {
              this.openOrderSummaryModal = true;
              this.dataOfTurnIntoOrder = value;
            },
            async dataLoad() {
                await this.$refs.preOrdersTable.dataLoad();
            },
            customerDocument(customer) {
                this.openCustomerModal = false
                this.chatTicket = {
                    id: null,
                    customer: customer,
                    document_register: customer.document_register
                }
                this.openCustomerDocumentModal = true
            },
            backToCustomer() {
                this.openCustomerDocumentModal = false
                this.openCustomerModal = true
            },
            sendToProductSericesFlow(data) {
                this.dataOfProductsToPreOrder = data;
                this.openCustomerDocumentModal = false;
                this.openProductsModal = true;
            },
            backToCustomerDocument () {
                this.openProductsModal = false;
                this.openCustomerDocumentModal = true;
            },
            addQuantity(value, dataToUpdate, services) {
                this.services = services;
                this.openProductsModal = false;

                if (this.isCreateContext && value.length === 0 && services.length !== 0) {
                    this.customerKnowledge = null;
                    this.dataOfProductsToPreOrder = [];
                    this.openCustomerKnowledgeModal = true;
                    return;
                }

                this.quantity_list = [];
                this.openQuantityModal = true;
                this.dataOfProductsToPreOrder.product = value;
                this.dataToUpdate = dataToUpdate;

                let lengthOfData = this.dataOfProductsToPreOrder.product === undefined ? this.dataOfProductsToPreOrder.length : this.dataOfProductsToPreOrder.product.length;

                for (let i = 1; i <= lengthOfData; i++) {
                    this.quantity_list.push(1);
                }
                this.$vs.loading.close('#app > .con-vs-loading');
            },
            popupKnowledge(next = false){
                if ( next === true ) {
                    this.openPaymentModal = true;
                } else if (this.dataOfProductsToPreOrder && this.dataOfProductsToPreOrder.delivery) {
                    this.openDeliveryModal = true;
                } else if ( this.services && this.services.length > 0 ){
                    return this.backToProducts()
                }
                this.customerKnowledge = null;
                this.openCustomerKnowledgeModal = false;
            },
            backToProducts(context) {
                if (context === 'serviceContext') {
                    this.cleanEvents();
                    this.customerKnowledge = null;
                    this.openPaymentModal = false;
                    this.openProductsModal = false;
                    this.openCustomerKnowledgeModal = true
                    return;
                }
                this.openCustomerKnowledgeModal = false
                this.openQuantityModal = false;
                this.openProductsModal = true;
                this.customerKnowledge = null;
                this.quantity_list = [];
            },
            sendDeliveryFlow(value) {
                this.openQuantityModal = false;
                this.openDeliveryModal = true;
                this.dataOfProductsToPreOrder = value;
            },
            cleanEvents() {
                this.$events.emit('cleanProducts', { 'file': 'Products' })
                this.$events.emit('cleanPayment', { 'file': 'Payment' })
                this.$events.emit('cleanDelivery', { 'file': 'Delivery' })
                this.$events.emit('cleanErp', { 'file': 'Erp' })
            },
            backToDiscountModalService(){
                this.openDiscountModal = false;
                this.openPreOrderSummaryModal = true;
            },          
            setDiscountPrice(data) {
                data.isService = false;
                this.dataToSetDiscount = data
                this.openDiscountModal = true;
                this.openQuantityModal = false;
            },
            setNewDiscountPrice(value, index) {
                this.openDiscountModal = false;
                this.openQuantityModal = true;
                if (this.dataOfProductsToPreOrder.product === undefined) {
                    this.dataOfProductsToPreOrder[index].discount_price = value
                } 
                else {
                    this.dataOfProductsToPreOrder.product[index].discount_price = value
                }
            },
            backToQuantity() {
                this.openDeliveryModal = false;
                this.openDiscountModal = false;
                this.openQuantityModal = true;
            },
            sendToPayment(value) {
                this.openDeliveryModal = false;
                this.dataOfProductsToPreOrder = value;
                if (this.services && this.services.length > 0){
                    this.customerKnowledge = null;
                    this.openCustomerKnowledgeModal = true;
                    return;
                }
                this.openPaymentModal = true;
            },
            closeModalPayment() {
                this.openPaymentModal = false;
                this.isCreateContext = true;
                this.cleanEvents();
            },
            updateOrderPayment(value) {
                this.dataOfTurnIntoOrder = value;
                this.openPaymentModal = false;
                this.openOrderSummaryModal = true;
                this.isCreateContext = true
            },
            backToDelivery() {
                this.openPaymentModal = false;
                if (this.services && this.services.length > 0){
                    this.customerKnowledge = null;
                    this.openCustomerKnowledgeModal = true;
                    return;
                }
                this.openDeliveryModal = true;
            },
            openDiscountServiceModal(data) {
                data.isService = true;
                this.dataToSetDiscount = data;
                this.openPreOrderSummaryModal = false;
                this.openDiscountModal = true;
            },
            editProductsPreOrder() {
                this.openPreOrderSummaryModal = false;
                this.openProductsModal = true;
                this.updatePreOrder = true;
            },
            updatePreOrderProducts() {
                this.openQuantityModal = false;
                this.openPreOrderSummaryModal = true;
                this.updatePreOrder = false;
            },
            setNewDiscountService(value, index) {
                this.openDiscountModal = false;
                this.openPreOrderSummaryModal = true;
                this.services[index].discount_price = value
            },
            closeModalPreOrders() {
                this.openPreOrderSummaryModal = false
                this.isCreateContext = true;
                this.cleanEvents();
            },
            backToPayment() {
                this.openNotesAndFilesPopUp = false;
                this.openPaymentModal = true;
                this.isCreateContext = true;
            },
            closeModalDelivery() {
                this.openDeliveryModal = false;
                this.isCreateContext = true;
                this.cleanEvents();
            },
            backToOrderSummary(value) {
                if (value === 'payment') {
                    this.openPaymentModal = false;
                } else if (value === 'product') { 
                    this.openProductsModal = false;
                    this.backIsVisible = false;
                } else if (value === 'quantity') {
                    this.openQuantityModal = false;
                    this.backIsVisible = false;
                } else {
                    this.openDeliveryModal = false;
                }
                this.isCreateContext = true;
                this.openOrderSummaryModal = true;
            },
            updateOrderDelivery(value) {
                this.dataOfTurnIntoOrder = value;
                this.openDeliveryModal = false;
                this.openOrderSummaryModal = true;
                this.isCreateContext = true
            },
            linkUser() {
                this.openOrderSummaryModal = false;
                this.openLinkUserPopUp = true;
            },
            backToOrerSummarry() {
                this.openLinkUserPopUp = false;
                this.openOrderSummaryModal = true;
            },
            setCurrentKnowledge(know){
                this.customerKnowledge = know;
            },
            changeUser(user) {
                this.openLinkUserPopUp = false;
                this.openOrderSummaryModal = true;
                this.selectedUser = user;
            },
            sendToPreOrdersSummary(files, note) {
                for (let index = 0; index < this.services.length; index++) {
                    this.services[index].discount_price = this.services[index].price
                    this.services[index].percentage_discount = 100;
                }
                this.openNotesAndFilesPopUp = false;
                this.openPreOrderSummaryModal = true;
                this.dataOfProductsToPreOrder.files = files;

                this.dataOfProductsToPreOrder.note = (note && note.trim() !== '') ? note : null;
            },
            sendToNotesAndFiles(value) {
                this.openPaymentModal = false;
                this.openNotesAndFilesPopUp = true;
                this.dataOfProductsToPreOrder = value;
            },
            backToNotesAndFiles() {
                this.openPreOrderSummaryModal = false;
                this.openNotesAndFilesPopUp = true;
            },
            backUpdateKnow(updateKnow) {
                this.isUpdate = false;
                this.openCustomerKnowledgeModal = false;
                this.openOrderSummaryModal = true;
                if (updateKnow) {
                    this.dataOfTurnIntoOrder.currentKnow = this.currentKnow
                }
            },
            editNotesAndFiles() {
                this.isUpdate = true;
                this.openOrderSummaryModal = false;
                this.openNotesAndFilesPopUp = true;
            },
            editCustomerKnow() {
                this.isUpdate = true;
                this.openOrderSummaryModal      = false;
                this.openCustomerKnowledgeModal = true;
            },
            addCustomerDocument() {
                this.openCustomerDocumentModal = true;
                this.openOrderSummaryModal = false;
                this.orderContext = 'finish'
            },
            backToFinishOrder() {
                this.orderContext = ''
                this.openCustomerDocumentModal = false;
                this.openOrderSummaryModal = true;
            }
        },
        computed: {
            currentUser() {
                return this.$store.state.AppActiveUser;
            }
        },
        async mounted() {
            await this.dataLoad(); 
            this.isMounted = true;
            this.selectedUser = this.currentUser;
        },
        beforeRouteLeave(to, from, next) {
            this.openOrderSummaryModal = false;
            this.openCustomerModal = false;
            this.openCustomerDocumentModal = false;
            this.openProductsModal = false;
            this.openQuantityModal = false;
            this.openDiscountModal = false;
            this.openDeliveryModal = false;
            this.openPaymentModal = false;
            this.openPreOrderSummaryModal = false;
            this.modalToTransformIsActive = false;
            this.openLinkUserPopUp = false;
            this.openNotesAndFilesPopUp = false;
            
            setTimeout( ()=> {
                next();
            }, 20);
        },
    }
</script>

<style lang="scss">
#preorders {
    * {
        margin: 0;
    }
    html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    .con-tablex.vs-table--content {
        width: 102%; 
    }
    table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 15px !important;
        padding: 0 1rem;
    }
    thead > tr {
        background-color: transparent !important;
    }
    .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    input.input-search.vs-table--search-input {
        height: 45px;
    }
    
    tbody {
        > tr {
            td {
                margin-bottom: 100px !important;
            }
            height: 5em;
            box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05%);
            .align-button-flex {
                .vs-button-text.vs-button--text {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    padding-left: 10px;
                }
            }
            td.vs-table--td:last-of-type {
                border-top-right-radius: 10px !important; 
                border-bottom-right-radius: 10px !important;
            }
            .td-check {
                border-top-left-radius: 10px !important; 
                border-bottom-left-radius: 10px !important;
                width: 45px;
            }
            .td-check.active-expanded {
                border-top-left-radius: 10px !important; 
            }
        }
        tr.tr-expand {
            > td {
                border-radius: 10px !important;
                div.content-tr-expand {
                    justify-content: space-between;
                    align-items: flex-end;
                    .order-infos-div {
                        display: flex;
                        div {
                            border: solid 2px #abb3b257; 
                            border-radius: 14px;
                            cursor: pointer;
                            margin: 8px;
                            width: 90px;
                            height: 80px;
                            display: flex;
                            flex-direction: column;
                            align-content: center;
                            justify-content: center;
                            align-items: center;
                            flex-wrap: wrap;

                            span {
                                font-size: 10px;
                                text-align: center;
                            }
                            img {
                                width: 40px;
                                height: 40px;
                                border-radius: 40px;
                            }
                        }
                    }
                }
            }
        }
    }
    #pixResize {
        width: 60px !important;
        height: 23px !important;
    }
    #cardResize {
        border-radius: 0 !important;
        height: 35px !important;
        width: 50px !important;
    }
    #cashResize {
        width: 40px !important;
        height: 30px !important;
    }
}
.order-infos-btn {
    button {
        display: flex;
        border-radius: 15px;
        height: 40px;
        align-items: center;
        width: 170px;
        justify-content: flex-end;
    }
    .vs-button-text.vs-button--text {
        display: flex;
    }
    span.vs-button-text.vs-button--text {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
}
</style>